import { createSlice } from '@reduxjs/toolkit';
import { map, filter } from 'lodash';
// actions
import getActionListaUsuariosByClienteId from "../../actions/usuarios/getActionListaUsuariosByClienteId";
import getActionListaRespostasRapidas from "../../actions/clientes/getActionListaRespostasRapidas";
import getActionListaSetoresByClienteId from "../../actions/clientes/getActionListaSetoresByClienteId";
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  myProfile: null,
  posts: [],
  users: [],
  setoresList: [],
  usuariosList: [],
  clientesMarketplace: [],
  listaUsuariosTransferencia: [],
  listaSetoresTransferencia: [],
  respostasRapidas: [],
  fluxoList: [],
  followers: [],
  friends: [],
  gallery: [],
  cards: null,
  addressBook: [],
  invoices: [],
  notifications: null,
  isUserStandby: false,
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PROFILE
    getProfileSuccess(state, action) {
      state.isLoading = false;
      state.myProfile = action.payload;
    },

    // GET POSTS
    getPostsSuccess(state, action) {
      state.isLoading = false;
      state.posts = action.payload;
    },

    // GET USERS
    getUsersSuccess(state, action) {
      state.isLoading = false;
      state.users = action.payload;
    },

    // DELETE USERS
    deleteUser(state, action) {
      const deleteUser = filter(state.userList, (user) => user.id !== action.payload);
      state.userList = deleteUser;
    },

    // GET FOLLOWERS
    getFollowersSuccess(state, action) {
      state.isLoading = false;
      state.followers = action.payload;
    },

    // ON TOGGLE FOLLOW
    onToggleFollow(state, action) {
      const followerId = action.payload;

      const handleToggle = map(state.followers, (follower) => {
        if (follower.id === followerId) {
          return {
            ...follower,
            isFollowed: !follower.isFollowed
          };
        }
        return follower;
      });

      state.followers = handleToggle;
    },

    // BUSCAR SETORES DE CLIENTES
    getUserListSetoresSuccess(state, action) {
      state.isLoading = false;
      state.setoresList = action.payload;
    },

    // BUSCAR USUARIOS DE CLIENTES
    getUserListUsuariosSuccess(state, action) {
      state.isLoading = false;
      state.usuariosList = action.payload;
    },

    // BUSCAR FLUXO DE CLIENTES
    getUserListFluxoSuccess(state, action) {
      state.isLoading = false;
      state.fluxoList = action.payload;
    },

    // BUSCAR LISTA DE USUARIOS BY CLIENTE ID
    getListaUsuariosByClienteIdSuccess(state, action) {
      state.isLoading = false;
      state.usuariosList = action.payload;
    },

    // BUSCAR LISTA DE USUARIOS PARA TRANSFERENCIA
    getListaUsuariosTransferenciaSuccess(state, action) {
      state.isLoading = false;
      state.listaUsuariosTransferencia = action.payload;
    },

    // BUSCAR LISTA DE SETORES PARA TRANSFERENCIA
    getListaSetoresTransferenciaSuccess(state, action) {
      state.isLoading = false;
      state.listaSetoresTransferencia = action.payload;
    },


    // BUSCAR LISTA REPSPOSTAS RAPIDAS
    getListaRespostasRapidasSuccess(state, action) {
      state.isLoading = false;
      state.respostasRapidas = action.payload;
    },



    // edit user standby
    setUserStandby(state, action) {
      state.isUserStandby = action.payload;
    },
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteUser, setUserStandby } = slice.actions;



// LISTA DE USAURIOS PARA TRANSFERENCIA

export function getListaUsuariosTransferencia(clienteId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getActionListaUsuariosByClienteId(clienteId);
      dispatch(slice.actions.getListaUsuariosTransferenciaSuccess(response.data.usuarios));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getListaUsuariosByClienteId(clienteId, showAll) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getActionListaUsuariosByClienteId(clienteId, showAll);
      dispatch(slice.actions.getListaUsuariosByClienteIdSuccess(response.data.usuarios));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// LISTA DE USAURIOS PARA TRANSFERENCIA

export function getListaSetoresTransferencia(clienteId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getActionListaSetoresByClienteId(clienteId);
      dispatch(slice.actions.getListaSetoresTransferenciaSuccess(response.data.setores));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



// ----------------------------------------------------------------------

export function getRespostasRapidas(clienteId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getActionListaRespostasRapidas(clienteId);
      console.log('response.data.respostas', response.data.respostas)
      dispatch(slice.actions.getListaRespostasRapidasSuccess(response.data.respostas));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getCards() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/cards');
      dispatch(slice.actions.getCardsSuccess(response.data.cards));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getAddressBook() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/address-book');
      dispatch(slice.actions.getAddressBookSuccess(response.data.addressBook));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getInvoices() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/invoices');
      dispatch(slice.actions.getInvoicesSuccess(response.data.invoices));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getNotifications() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/account/notifications-settings');
      dispatch(slice.actions.getNotificationsSuccess(response.data.notifications));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getUsers() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/user/all');
      dispatch(slice.actions.getUsersSuccess(response.data.users));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
